import {defineAsyncComponent} from 'vue'
const TaskRouter = [
  {
    path: 'taskcenter',
    name: 'TaskCenter',
    component: () => import('@/views/Task/TaskCenter/Index.vue'),
    meta: {
      key: 'task'
    }
  },
]
export {TaskRouter}
